/** Largest page the list endpoint serves; the wizard session list is read in one request. */
export const FEC_IMPORT_LIST_MAX_LIMIT = 200
